/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiReservedConversionFromJSON, ApiReservedConversionToJSON, } from './ApiReservedConversion';
import { ApiReservedPageTypesFromJSON, ApiReservedPageTypesToJSON, } from './ApiReservedPageTypes';
export function ApiGenerateInteractionFromJSON(json) {
    return ApiGenerateInteractionFromJSONTyped(json, false);
}
export function ApiGenerateInteractionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'interaction': !exists(json, 'interaction') ? undefined : ApiReservedConversionFromJSON(json['interaction']),
        'pageType': !exists(json, 'pageType') ? undefined : ApiReservedPageTypesFromJSON(json['pageType']),
    };
}
export function ApiGenerateInteractionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'interaction': ApiReservedConversionToJSON(value.interaction),
        'pageType': ApiReservedPageTypesToJSON(value.pageType),
    };
}
